import { useEffect, useState, type InputHTMLAttributes } from "react";
import { formatQty, toQ4 } from "@cx/domain";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> & {
  value: number | null;
  onChange(q4: number | null): void;
  decimals?: number;
};

export function QtyInput({
  value,
  onChange,
  decimals = 0,
  className = "form-control text-end",
  ...rest
}: Props) {
  const show = (q: number | null) => (q === null ? "" : formatQty(q, decimals));
  const [text, setText] = useState(show(value));
  const [invalid, setInvalid] = useState(false);
  useEffect(() => {
    setText(show(value));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const marked = invalid || rest["aria-invalid"] === "true" || rest["aria-invalid"] === true;
  return (
    <input
      {...rest}
      inputMode="decimal"
      className={`${className}${marked ? " is-invalid" : ""}`}
      aria-invalid={marked ? "true" : undefined}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={() => {
        if (text.trim() === "") {
          setInvalid(false);
          onChange(null);
          return;
        }
        try {
          const q = toQ4(text);
          setInvalid(false);
          setText(show(q));
          onChange(q);
        } catch {
          setInvalid(true);
        }
      }}
    />
  );
}
